import React, {Component} from "react";
import Moment from "react-moment"
import moment, {now} from 'moment';
import localization from 'moment/locale/nl';
import 'react-dates/initialize';
import {SingleDatePicker} from 'react-dates';
import TimeField from 'react-simple-timefield';
import Dropdown from 'react-dropdown';
import {ReactComponent as ReactAddIcon} from "../recources/icons/add-icon.svg"
import {ReactComponent as ReactEditIcon} from "../recources/icons/edit-icon.svg"
import {ReactComponent as ReactCloseIcon} from "../recources/icons/close-icon.svg"
import { ReactComponent as ReactDeleteIcon } from "../recources/icons/delete-icon.svg"
import {ReactComponent as ReactDropdownArrow} from "../recources/icons/formarrow.svg"
import formArrow from "../recources/icons/formarrow.svg";
import Header from "../Header";
import axios from "axios";

class Home extends Component {

    getAllAgendasFromDatabase() {
        axios.post(
            "/agenda/get_agendas",
            {
                instantie_id: this.state.loggedInUser.instantie_id,
                rollen: [1, 2],
                user_rollen : this.state.loggedInUser.rollen,
                
            },
            {withCredentials: true}
        ).then((response) => {
            this.setState({
                agendas: response.data,
            });

            if (sessionStorage.getItem('datumDropdownValue') !== 'null' || sessionStorage.getItem('orgaanDropdownValue') !== 'null') {
                this.reloadFilters()
            }
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            modalTitle: "Nieuwe jaarplanning aanmaken",
            modalButton: "Maak aan",
            agendas: "",
            types: [],
            organen: [],
            form: {
                id: 0,
                type: "",
                orgaan: "",
                instantie: "",
                start_time: "",
                end_time: "",
                date: "",
            },
            focused: false,
            removeId: "",
            removeAgendaOrgaan: "",
            removeAgendaDatum: "",
            errorMessageToggle: false,
            errorMessage: "",
            filteredAgendas: [],
            datumDropdownValue: null,
            orgaanDropdownValue: null,
            scrolledToMonth: false,
            loggedInUser: JSON.parse(localStorage.getItem("914ebf336ee44d9deba3f19de35417ace22dc318b8a1024bcd9fe9b4f083a9ae")),
        }

        moment.locale('nl', localization);

        this.getAllAgendasFromDatabase();

        axios.get("/agenda/get_types", {
            withCredentials: true,
        }).then((response) => {
            this.setState({
                types: response.data,
            });
        });

        axios.post("/rollen/get_organen", 
        {
            instantie_id: this.state.loggedInUser.instantie_id,
        },
        {
            withCredentials: true,
        }).then((response) => {
            this.setState({
                organen: response.data,
            });
        });

        this.openAddEditModal = this.openAddEditModal.bind(this);
        this.handleOnChangeAgendaForm = this.handleOnChangeAgendaForm.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.handleSubmitAddAgenda = this.handleSubmitAddAgenda.bind(this);
        this.handleRemoveAgendaAccepted = this.handleRemoveAgendaAccepted.bind(this);
        this.handleOpenAgenda = this.handleOpenAgenda.bind(this);
        this.hasLoggedInUserRechtOpAgenda = this.hasLoggedInUserRechtOpAgenda.bind(this);
        this.filterOrganenVoorLoggedInUser = this.filterOrganenVoorLoggedInUser.bind(this);
    }

    componentDidMount() {
        let bewerkRechten = false;
        if (this.state.loggedInUser && this.state.loggedInUser.rechten && this.state.loggedInUser.rechten.filter(b => b === 2).length > 0) {
            // Gebruiker heeft bewerkrechten op tenminste 1 orgaan.
            bewerkRechten = true;
        }
        let user = this.state.loggedInUser;
        user.bewerkRechten = bewerkRechten;
        this.setState({ loggedInUser: user })
    }

    setError(errorMessage) {
        window.clearTimeout();
        this.setState({
            errorMessageToggle: true,
            errorMessage: errorMessage
        });
        const errorMessageToggleFalse = () => {
            this.setState({errorMessageToggle: false});
        }
        setTimeout(errorMessageToggleFalse, 5000);
    }

    resetFormFields() {
        this.setState({
            form: {
                id: null,
                type: "1",
                orgaan: "",
                instantie: this.state.loggedInUser.instantie_id,
                start_time: "",
                end_time: "",
                date: "",
            }
        })
    }

    openAddEditModal(id, event) {
        event.stopPropagation();
        const body = document.querySelector('body')
        body.style.overflow = "hidden"
        if (typeof id !== 'string') {
            this.setState({modalTitle: "Nieuwe agenda aanmaken"});
            this.setState({modalButton: "Maak aan"});
            this.resetFormFields();
        } else {
            this.setState({modalTitle: "Agenda wijzigen"});
            this.setState({modalButton: "Wijzigen"});
            const agendaToEdit = this.state.agendas.find(x => x.id === id);
            const agendaOrgaanToEdit = this.state.organen.find(x => x.rol === agendaToEdit.orgaan).id;
            const agendaTypeToEdit = this.state.types.find(x => x.naam === agendaToEdit.type_agenda).id;
            const agendaDateToEdit = moment(agendaToEdit.datum);
            this.setState({
                form: {
                    id: agendaToEdit.id,
                    type: agendaTypeToEdit,
                    orgaan: agendaOrgaanToEdit,
                    instantie: this.state.loggedInUser.instantie_id,
                    start_time: agendaToEdit.start_tijd,
                    end_time: agendaToEdit.eind_tijd,
                    date: agendaDateToEdit,
                }
            });
        }
        let modal = document.getElementById("add-edit-year-planning-modal");
        modal.style.display = "block";
        modal.style.opacity = 1;
    }

    openRemoveModal(agenda, event) {
        event.stopPropagation();
        this.setState({ 
            removeId: agenda.id,
            removeAgendaOrgaan: agenda.orgaan,
            removeAgendaDatum: agenda.datum
        })
        let modal = document.getElementById("remove-confirm-modal");
        modal.style.display = "block";
        modal.style.opacity = 1;
    }

    closeModals() {
        const body = document.querySelector('body')
        body.style.overflow = "auto"
        let addEditModal = document.getElementById("add-edit-year-planning-modal");
        let removeConfirmModal = document.getElementById("remove-confirm-modal");
        addEditModal.style.display = "none";
        addEditModal.style.opacity = 0;
        removeConfirmModal.style.display = "none";
        removeConfirmModal.style.opacity = 0;
    }

    hasLoggedInUserRechtOpAgenda(orgaan, recht) {
        let hasRecht = false;

        if (this.state.loggedInUser.rollen) {
            const index = this.state.loggedInUser.rollen.findIndex(r => r === orgaan);
            if (index >= 0) {
                hasRecht = this.state.loggedInUser.rechten[index] === recht;
            } 
        }

        return hasRecht;
    }

    agendaTableRows() {
        let agendas = this.state.agendas;
        let currentMonth = '';
        let scrolledToMonth = false


        if (this.state.filteredAgendas.length !== 0) {
            agendas = this.state.filteredAgendas
        }

        if (this.state.filteredAgendas === "no results") {
            return (
                <tbody>
                <td colSpan="7" className="px-4">Met de geselecteerde filters zijn er geen agenda's</td>
                </tbody>
            )
        }

        const scrollTo = (ref, datum) => {
            let scrollToMonth = moment()
            if (ref && moment(datum).isSameOrAfter(scrollToMonth) && !this.state.scrolledToMonth && !scrolledToMonth) {
                this.setState({
                    scrolledToMonth: true
                })
                scrolledToMonth = true;
                setTimeout(function () {
                    ref.scrollIntoView()
                    window.scrollBy(0, -80)
                }, 50)
            }
        }

        return (
            Object.keys(agendas).map(key => {
                const startTime = moment(agendas[key].start_tijd, "HH:mm:ss");
                const endTime = moment(agendas[key].eind_tijd, "HH:mm:ss");

                const agendaInThePast = moment(agendas[key].datum).isBefore(now());
                const isGebruikerBewerker = this.hasLoggedInUserRechtOpAgenda(agendas[key].orgaan, 2);
                const isGebruikerBekijker = this.hasLoggedInUserRechtOpAgenda(agendas[key].orgaan, 3);

                function monthHeader() {
                    if (currentMonth !== moment(agendas[key].datum).format('MMM')) {
                        currentMonth = moment(agendas[key].datum).format('MMM')
                        return (
                            <thead id={currentMonth} ref={ref => scrollTo(ref, agendas[key].datum)}>
                            <tr>
                                <th colSpan="8" className="month-label" scope="col"><Moment format="MMM YYYY" date={agendas[key].datum}/></th>
                            </tr>
                            </thead>
                        )
                    } else {
                        currentMonth = moment(agendas[key].datum).format('MMM')
                    }
                }

                return (
                    <>
                        { monthHeader() }
                        <tbody>
                            <tr key={agendas[key].id} onClick={event => this.handleOpenAgenda(event, agendaInThePast, agendas[key].id, isGebruikerBewerker, isGebruikerBekijker)} className={agendaInThePast ? "grayed" : ""}>
                                <td>{agendas[key].type_agenda}</td>
                                <td>{agendas[key].orgaan}</td>
                                <td>{agendas[key].instantie} {agendas[key].logo_klein ? "[logo]" : ""}</td>
                                <td><Moment format="DD MMM YYYY" date={agendas[key].datum}/></td>
                                <td className="time-row"><Moment date={startTime} format="HH:mm"/> - <Moment date={endTime} format="HH:mm"/></td>
                                { isGebruikerBewerker && !agendaInThePast ? <td onClick={event => this.openAddEditModal(agendas[key].id, event)}><ReactEditIcon/></td> : <td></td> }
                                { isGebruikerBewerker ? <td className="text-center  delete-table-row" onClick={event => this.openRemoveModal(agendas[key], event)}><ReactDeleteIcon/></td> : <td></td> }
                            </tr>
                        </tbody>
                    </>
                )
            })
        )
    }

    handleOpenAgenda(event, agendaInThePast, agendaId, isGebruikerBewerker, isGebruikerBekijker) {
        if (!isGebruikerBewerker && !isGebruikerBekijker) return;

        if (agendaInThePast) {
            if (isGebruikerBewerker || isGebruikerBekijker) {
                this.props.history.push(`/agenda/${agendaId}?readonly=true`);
            }
        } else {
            if (isGebruikerBewerker) {
                this.props.history.push(`/agenda/${agendaId}`);
            } else if (isGebruikerBekijker) {
                this.props.history.push(`/agenda/${agendaId}?readonly=true`);
            }
        }
    }

    handleOnChangeAgendaForm(event) {
        const name = event.target.name;
        const value = event.target.value;
        const newFormData = this.state.form;
        newFormData[name] = value;
        this.setState({
            form: newFormData
        })
    }

    formagendaTypesSelectField() {
        const types = this.state.types;
        return (
            <select required value={this.state.form.type} onChange={this.handleOnChangeAgendaForm}
                    className="addformpopup" name="type" disabled>
                <option value="">Type bestand</option>
                {types.map(value => {
                    return (<option key={value.id} value={value.id}>{value.naam}</option>)
                })}
            </select>
        )
    }

    // Deze functie werkt op de globale state
    filterOrganenVoorLoggedInUser() {
        let filteredOrganen = [];

        if (!this.state.loggedInUser || !this.state.loggedInUser.rechten || 
            !this.state.loggedInUser.rollen || !this.state.organen) return filteredOrganen;

        this.state.loggedInUser.rechten.forEach((r, i) => {
            if (r === 2) {
                const orgaan = this.state.organen.find(o => o.id === this.state.loggedInUser.rol_ids[i]);
                if (orgaan) {
                    filteredOrganen.push(orgaan);
                }
            }
        });

        return filteredOrganen;
    }

    formagendaOrganenSelectField() {
        const organen = this.filterOrganenVoorLoggedInUser();

        return (
            <select required value={this.state.form.orgaan} onChange={this.handleOnChangeAgendaForm}
                    className="add-form-popup" name="orgaan"
                    style={{ backgroundImage: `url(${formArrow})` }}>
                <option value="">Orgaan</option>
                {organen.map(value => {
                    return (<option key={value.id} value={value.id}>{value.rol}</option>)
                })}
            </select>
        )
    }

    onChangeDate(dateData) {
        const newFormData = this.state.form;
        newFormData.date = dateData;
        this.setState({
            form: newFormData
        })
    }

    setTime(data, timeType) {
        const newFormData = this.state.form;
        newFormData[timeType] = data.target.defaultValue;
        this.setState({
            form: newFormData
        })
    }

    handleSubmitAddAgenda(e) {
        e.preventDefault();

        if (moment(this.state.form.date).format() === "Invalid date"){
            this.setError("Datum veld is geen correcte datum. Wijziging is niet opgeslagen!");
            return;
        } else if (moment(this.state.form.end_time, 'HH:mm').isBefore(moment(this.state.form.start_time, 'HH:mm'))) {
            this.setError("Eindtijd kan niet eerder dan begintijd zijn. Wijziging is niet opgeslagen!");
            return;
        } else if (this.state.form.start_time === '' || this.state.form.end_time === '') {
            this.setError("Tijd veld kan niet 00:00 zijn. Wijziging is niet opgeslagen!");
            return;
        }

        if (this.state.form.id === null) {
            const formattedFormData = {
                instantie_id: this.state.form.instantie,
                type_id: parseInt(this.state.form.type),
                orgaan_id: parseInt(this.state.form.orgaan),
                datum: moment(this.state.form.date).format(),
                start_tijd: moment(this.state.form.start_time, 'HH:mm').format('HH:mm:ss'),
                eind_tijd: moment(this.state.form.end_time, 'HH:mm').format('HH:mm:ss'),
            }
            axios.post(
                "/agenda/add_agenda",
                {
                    agenda: formattedFormData,
                    rechten: [1, 2],
                    rollen: [1, 2],
                    instantie_id: this.state.loggedInUser.instantie_id
                },
                {withCredentials: true}
            ).then(() => {
                this.resetFormFields();
                this.getAllAgendasFromDatabase();
                this.closeModals();
            });

        } else {
            const formattedFormData = {
                id: this.state.form.id,
                instantie_id: this.state.form.instantie,
                type_id: parseInt(this.state.form.type),
                orgaan_id: parseInt(this.state.form.orgaan),
                datum: moment(this.state.form.date).format(),
                start_tijd: moment(this.state.form.start_time, 'HH:mm').format('HH:mm:ss'),
                eind_tijd: moment(this.state.form.end_time, 'HH:mm').format('HH:mm:ss'),
            }
            const toEditVariables = ["instantie_id", "type_id", "orgaan_id", "datum", "start_tijd", "eind_tijd"];

            toEditVariables.map(toEdit => {
                axios.post(
                    "/agenda/update_agenda",
                    {
                        agenda: {
                            id: this.state.form.id,
                            column: toEdit,
                            value: formattedFormData[toEdit],
                        },
                    },
                    {withCredentials: true}
                ).then(() => {
                    this.resetFormFields();
                    this.getAllAgendasFromDatabase();
                    this.closeModals();
                });
            })
        }
    }

    handleRemoveAgendaAccepted() {
        const agendaIdToRemove = this.state.removeId;
        axios.post(
                "/agenda/remove_agenda",
                {
                    id: agendaIdToRemove,
                },
                { withCredentials: true }
            ).then(() => {
                this.getAllAgendasFromDatabase();
                this.closeModals();
            });
    }

    reloadFilters() {
        let datumDropdownValue = sessionStorage.getItem('datumDropdownValue')
        let orgaanDropdownValue = sessionStorage.getItem('orgaanDropdownValue')
        datumDropdownValue === 'null' ? datumDropdownValue = null : null
        orgaanDropdownValue === 'null' ? orgaanDropdownValue = null : null
        let filteredAgendas = this.state.agendas
        if (datumDropdownValue && !orgaanDropdownValue) {
            filteredAgendas = this.state.agendas.filter(agenda => moment(agenda['datum']).format("YYYY") === datumDropdownValue)
        } else if (orgaanDropdownValue && !datumDropdownValue) {
            filteredAgendas = this.state.agendas.filter(agenda => agenda['orgaan'] === orgaanDropdownValue)
        } else if (orgaanDropdownValue && datumDropdownValue) {
            filteredAgendas = this.state.agendas.filter(function (result) {
                return moment(result['datum']).format("YYYY") === datumDropdownValue && result['orgaan'] === orgaanDropdownValue;
            } );
        }

        if (filteredAgendas.length === 0) {
            filteredAgendas = "no results"
        }

        this.setState({
            filteredAgendas: filteredAgendas
        })
    }

    render() {

        const onClickTimeField = (element) => {
            if (element.target.selectionStart === 5) {
                element.target.setSelectionRange(0, 0);
            }
        }

        const dropdownValuesGenerator = (toSearchFor) => {
            let output = [{ value: null, label: 'Alle' }]
            let flags = []
            let length = this.state.agendas.length, i;

            for( i=0; i<length; i++) {
                let agenda = this.state.agendas[i][toSearchFor]

                if (toSearchFor === 'datum') {
                    agenda = moment(agenda).format('YYYY')
                }

                if( flags[agenda]) continue;
                flags[agenda] = true;
                output.push(
                    { value: agenda, label: agenda }
                );
            }

            return output
        }

        const onChangeFunction = (filterValue, filterName) => {

            let stateName = filterName + 'DropdownValue';
            sessionStorage.setItem(stateName, filterValue);
                this.reloadFilters()
        }

        const orgaanFilterValue = sessionStorage.getItem('orgaanDropdownValue') === 'null' ? null : sessionStorage.getItem('orgaanDropdownValue')
        const datumFilterValue = sessionStorage.getItem('datumDropdownValue') === 'null' ? null : sessionStorage.getItem('datumDropdownValue')

        return (
            <>
                <Header titlePage="Overzicht agenda's" formatOption="1"  />


                <div className="year-plannings">
                    <table className="table overview"   >
                        <thead >
                        <tr>
                            <th scope="col">Type</th>
                            <th scope="col">
                                <div className="table-dropdown" >
                                Orgaan
                                    <Dropdown options={dropdownValuesGenerator('orgaan')}
                                              placeholder="Alle"
                                              onChange={event => onChangeFunction(event.value, 'orgaan')}
                                              value={orgaanFilterValue}
                                    />
                                <ReactDropdownArrow />
                                </div>
                            </th>
                            <th scope="col">Instantie</th>
                            <th scope="col">
                                <div className="table-dropdown">
                                Datum
                                    <Dropdown options={dropdownValuesGenerator('datum')}
                                              placeholder="Alle"
                                              onChange={event => onChangeFunction(event.value, 'datum')}
                                              value={datumFilterValue}
                                    />
                                <ReactDropdownArrow/>
                                </div>
                                </th>
                            <th scope="col">Tijd</th>
                            <th scope="col" className="text-center">Wijzig</th>
                            <th scope="col" className="text-right" >Verwijder</th>
                            {/* <p className="hide-shadow"></p> */}
                        </tr>
                        </thead>
                        {this.agendaTableRows()}
                        {/*<thead>*/}
                        {/*<tr>*/}
                        {/*    <th colSpan="6" className="month-label" scope="col">Juli 2021</th>*/}
                        {/*</tr>*/}
                        {/*</thead>*/}
                    </table>

                    { 
                        this.state.loggedInUser.bewerkRechten ? 
                            <div onClick={event => this.openAddEditModal(undefined, event)} className="new-year-planning" >
                                <ReactAddIcon/>Nieuwe agenda aanmaken
                            </div> :
                            <div className="new-year-planning">Gebruiker heeft geen rechten om een nieuwe agenda aan te maken</div>
                    }

                    <div id="add-edit-year-planning-modal" className="modal">
                        <div className="modal-content">
                            <div className="modal-head">
                                {this.state.modalTitle}
                            </div>
                            <ReactCloseIcon onClick={this.closeModals} className="close-icon"/>
                            <form onSubmit={this.handleSubmitAddAgenda} style={{padding: "40px 100px"}} className="add-form-popup">
                                <div className="row">
                                    <div className="col-md-6">
                                        <p>Type</p>
                                    <div className="center-noMargin">

                                        {this.formagendaTypesSelectField()}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <p>Orgaan</p>
                                    <div className="center-witMargin">
                                        {this.formagendaOrganenSelectField()}
                                    </div>
                                    </div>
                                    <div className="col-md-6">
                                        <p>Instantie</p>
                                        <div className="center-noMargin">
                                            {/* Erg vreemde manier om instantie te tonen, maar het werkt */}
                                            <select required value=""
                                                    onChange={this.handleOnChangeAgendaForm} name="instantie"
                                                    className="add-form-popup" disabled>
                                                <option value="">{this.state.loggedInUser.instantie_naam}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <p>Datum</p>
                                            <SingleDatePicker
                                                required
                                                date={this.state.form.date ? this.state.form.date : null}
                                                onDateChange={date => this.onChangeDate(date)}
                                                focused={this.state.focused}
                                                onFocusChange={({focused}) => this.setState({focused})}
                                                placeholder="Datum (DD/MM/JJJJ)"
                                                displayFormat={() => "DD/MM/YYYY"}
                                            />
                                    </div>
                                    <div className="col-md-6">
                                        <p>Aanvang</p>
                                        <div className="center-noMargin">
                                        <TimeField
                                            onClick={element => onClickTimeField(element)}
                                            required
                                            value={this.state.form.start_time}
                                            onChange={value => {
                                                this.setTime(value, "start_time")
                                            }}
                                            input={<input type="text" className="add-form-popup"/>}
                                            colon=":"
                                            className={this.state.form.start_time === "00:00:00" ? "empty-time-field" : null}
                                        />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <p>Einde</p>
                                        <div className="center-noMargin">
                                        <TimeField
                                            onClick={element => onClickTimeField(element)}
                                            required
                                            value={this.state.form.end_time}
                                            onChange={value => {
                                                this.setTime(value, "end_time")
                                            }}
                                            input={<input type="text" className="add-form-popup"/>}
                                            colon=":"
                                            className={this.state.form.end_time === "00:00:00" ? "empty-time-field" : null}
                                        />
                                        </div>
                                    </div>
                                    {/*<div className="col-md-6">*/}
                                    {/*    <input type="text" className="add-form-popup" placeholder="Weergaverechten"/>*/}
                                    {/*</div>*/}
                                    {/*<div className="col-md-6">*/}
                                    {/*    <input type="text" className="add-form-popup" placeholder="Bewerkingsrechten"/>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="row">
                                    <input className="button" role="button" type="submit"
                                           value={this.state.modalButton}/>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div id="remove-confirm-modal" className="modal">
                        <div className="modal-content">
                            <div className="modal-head">
                                Weet u zeker dat u deze agenda wilt verwijderen?
                            </div>
                            <ReactCloseIcon onClick={this.closeModals} className="close-icon"/>
                            <form action="">
                            <div  className="user-for-deletion">{this.state.removeAgendaOrgaan} {moment(this.state.removeAgendaDatum).format("DD-MM-YYYY")}</div>
                                <div className="row">
                                    <div className="col-sm-6 m-auto d-flex">
                                        <input onClick={this.handleRemoveAgendaAccepted} className="button" role="button" type="button" value="Ja"/>
                                    </div>
                                    <div className="col-sm-6 m-auto d-flex">
                                        <input onClick={this.closeModals} className="button gray" role="button"
                                               type="button" value="Nee"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={this.state.errorMessageToggle ? "error-message" : "error-message d-none"}>{this.state.errorMessage}</div>
            </>
        );
    }
}

export default Home;